'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = lassoFormWrapper;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactForm = require('react-form');

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _moveto = require('moveto');

var _moveto2 = _interopRequireDefault(_moveto);

var _bdcoreData = require('@bd/bdcore-data');

var _bdcoreData2 = _interopRequireDefault(_bdcoreData);

var _bdcoreUtilities = require('@bd/bdcore-utilities');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var leadLocation = 'https://www.mybuildercloud.com/_admin/API/lead.php';

function lassoFormWrapper(formProps) {
  return function (WrappedComonent) {
    var LassoForm = function (_React$Component) {
      _inherits(LassoForm, _React$Component);

      function LassoForm(props) {
        _classCallCheck(this, LassoForm);

        var _this = _possibleConstructorReturn(this, (LassoForm.__proto__ || Object.getPrototypeOf(LassoForm)).call(this, props));

        _this.state = {
          firstFocus: undefined
        };

        _this.preSubmit = _this.preSubmit.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onSubmitFailure = _this.onSubmitFailure.bind(_this);
        _this.setFormRef = _this.setFormRef.bind(_this);
        _this.handleFocus = _this.handleFocus.bind(_this);
        _this.handleBlur = _this.handleBlur.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
      }

      _createClass(LassoForm, [{
        key: 'handleFocus',
        value: function handleFocus(event) {
          if (!this.state.firstFocus) {
            this.setState({ firstFocus: Date.now() });
          }
          var varName = _lodash2.default.get(event, 'target.name', '') + 'FirstFocused';
          if (!this.state[varName]) {
            this.setState(_defineProperty({}, varName, new Date().toISOString()));
          }
        }
      }, {
        key: 'handleBlur',
        value: function handleBlur(event) {
          var varName = _lodash2.default.get(event, 'target.name', '') + 'FirstBlurred';
          if (!this.state[varName]) {
            this.setState(_defineProperty({}, varName, new Date().toISOString()));
          }
        }
      }, {
        key: 'handleClick',
        value: function handleClick(event) {
          if (!this.state.firstClickXPos && !this.state.firstClickYPos) {
            this.setState({ firstClickXPos: _lodash2.default.get(event, 'clientX', '') });
            this.setState({ firstClickYPos: _lodash2.default.get(event, 'clientY', '') });
          }
          this.setState({ submitXPos: _lodash2.default.get(event, 'clientX', '') });
          this.setState({ submitYPos: _lodash2.default.get(event, 'clientY', '') });
        }
      }, {
        key: 'onSubmit',
        value: function onSubmit(values) {
          var _this2 = this;

          if (this.state.submitted) {
            return;
          }

          var leadUrl = _bdcoreUtilities.ConfigStore.getConfig('Forms.Lasso.leadUrl', leadLocation);

          this.setState({
            submitted: true
          });

          _axios2.default.post(leadUrl, values).then(function () {
            _this2.setState({
              success: true
            });
          }).catch(function (error) {
            _this2.setState({
              error: error,
              submitted: false
            });
          });
        }
      }, {
        key: 'onSubmitFailure',
        value: function onSubmitFailure() {
          var _document$getElements = document.getElementsByClassName('form-control is-invalid'),
              _document$getElements2 = _slicedToArray(_document$getElements, 1),
              firstError = _document$getElements2[0];

          if (firstError && this.ref.contains(firstError)) {
            var moveTo = new _moveto2.default({
              tolerance: 40
            });
            moveTo.move(firstError);
          }

          this.setState({
            submitted: false
          });
        }
      }, {
        key: 'setFormRef',
        value: function setFormRef(node) {
          this.ref = node;
        }
      }, {
        key: 'preSubmit',
        value: function preSubmit(values) {
          var _props = this.props,
              area = _props.area,
              builder = _props.builder,
              community = _props.community,
              home = _props.home,
              metro = _props.metro,
              plan = _props.plan,
              settings = _props.settings,
              submetro = _props.submetro,
              utmCodes = _props.utmCodes;

          var websiteTime = this.state.firstFocus ? Date.now() - this.state.firstFocus : 101;
          var firstName = void 0;
          var lastName = void 0;

          if (_lodash2.default.has(values, 'fullName')) {
            var _$get$trim$match = _lodash2.default.get(values, 'fullName', '').trim().match(/^(.*)\s([^\s]{1,})$/);

            var _$get$trim$match2 = _slicedToArray(_$get$trim$match, 3);

            firstName = _$get$trim$match2[1];
            lastName = _$get$trim$match2[2];
          }

          var metrics = {
            forms: _extends({}, this.state)
          };

          var submitValues = _extends({
            area: _lodash2.default.get(area, 'name'),
            areaMetro: _lodash2.default.get(metro, 'name'),
            areaSubmetro: _lodash2.default.get(submetro, 'name'),
            _builder_id: _lodash2.default.get(builder, '_id'),
            domainAccountId: _lodash2.default.get(settings, 'lassos[0].domainAccountId'),
            com: _lodash2.default.get(community, '_id'),
            Community: _lodash2.default.get(community, 'name'),
            mod: _lodash2.default.get(plan, '_id'),
            Model: _lodash2.default.get(plan, 'name'),
            inv: _lodash2.default.get(home, '_id'),
            Inventory: _lodash2.default.get(home, 'address.streetAddress'),
            url: window.location.href,
            firstName: firstName,
            lastName: lastName,
            websiteTime: websiteTime,
            metrics: metrics
          }, utmCodes, values);

          var LassoCRM = window.LassoCRM;
          if (LassoCRM && typeof _lodash2.default.get(LassoCRM, 'tracker.readCookie') === 'function') {
            submitValues.guid = LassoCRM.tracker.readCookie('ut');
          } else if (LassoCRM && Array.isArray(LassoCRM.trackers)) {
            // Support for multiple trackers
            // This is non-standard as lasso did not have a method to accomplish this.
            submitValues.lassoTrackers = LassoCRM.trackers.map(function (tracker) {
              return {
                domainAccountId: tracker.accountId,
                guid: tracker.guid
              };
            });
          }

          var cookies = '; ' + document.cookie;
          var parts = cookies.split('; hubspotutk=');
          if (parts.length === 2) {
            var hubspotutk = parts.pop().split(';').shift();
            if (hubspotutk) {
              _lodash2.default.set(submitValues, 'crm.hubspot.hutk', hubspotutk);
            }
          }

          return submitValues;
        }
      }, {
        key: 'render',
        value: function render() {
          var _this3 = this;

          var success = this.state.success;


          return _react2.default.createElement(
            _reactForm.Form,
            Object.assign({
              preSubmit: this.preSubmit,
              onSubmit: this.onSubmit,
              onSubmitFailure: this.onSubmitFailure
            }, formProps),
            function (formApi) {
              if (success) {
                var formData = formApi.getFormState().values;
                var formName = formData.formLabel || formData.formName || 'Unnamed Form';

                if (typeof window.ga === 'function') {
                  window.ga('send', 'event', 'formSubmission', 'Submit', formName);
                }
                if (Array.isArray(window.dataLayer)) {
                  window.dataLayer.push({
                    event: 'formSubmission',
                    eventCategory: 'Form',
                    eventAction: formName,
                    formData: formData
                  });
                }
              }

              return _react2.default.createElement(
                'form',
                { onFocus: _this3.handleFocus, onClick: _this3.handleClick, onBlur: _this3.handleBlur,
                  onSubmit: formApi.submitForm, ref: _this3.setFormRef },
                _react2.default.createElement(WrappedComonent, Object.assign({}, _this3.props, { success: success, formApi: formApi }))
              );
            }
          );
        }
      }]);

      return LassoForm;
    }(_react2.default.Component);

    LassoForm.propTypes = {
      area: _propTypes2.default.object,
      builder: _propTypes2.default.object.isRequired,
      community: _propTypes2.default.object,
      home: _propTypes2.default.object,
      metro: _propTypes2.default.object,
      plan: _propTypes2.default.object,
      settings: _propTypes2.default.object.isRequired,
      submetro: _propTypes2.default.object,
      utmCodes: _propTypes2.default.object
    };

    LassoForm.defaultProps = {
      area: undefined,
      community: undefined,
      home: undefined,
      metro: undefined,
      plan: undefined,
      submetro: undefined,
      utmCodes: undefined
    };

    return (0, _bdcoreData2.default)({
      settings: true,
      builder: true,
      home: true,
      plan: true,
      community: true,
      metro: true,
      submetro: true,
      area: true,
      utmCodes: true
    }, {
      required: {
        settings: true,
        builder: true
      }
    })(LassoForm);
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdui-forms/build/lassoForm.js
// module id = 1121
// module chunks = 0